import React from 'react';

const HtmlIcon = () => {
  return <img src='/skill-icons/html.png' alt='html-logo' />;
};

export default HtmlIcon;
